const YtIntro = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19.99 14' {...props}>
    <path d='M19.58 2.19a2.48 2.48 0 0 0-1.76-1.76c-1.56-.43-7.82-.43-7.82-.43s-6.26 0-7.83.41a2.55 2.55 0 0 0-1.76 1.78 26.55 26.55 0 0 0-.41 4.81 26.43 26.43 0 0 0 .41 4.81 2.5 2.5 0 0 0 1.76 1.76c1.59.43 7.83.43 7.83.43s6.26 0 7.82-.41a2.5 2.5 0 0 0 1.76-1.76 26.55 26.55 0 0 0 .42-4.83 24.93 24.93 0 0 0-.42-4.81zm-11.58 7.81v-6l5.21 3z' />
  </svg>
)

export default YtIntro



// WEBPACK FOOTER //
// ./components/icons/yt-intro.js